import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import AddUserIcon from '@mui/icons-material/Add';
import AddUserImage from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Dropzone from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Selector from '../select';
import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from 'react-material-ui-form-validator';
import { toast } from 'react-toastify';
import spinner from '../assign-prescriptions/images/spinner.gif';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import {
  AppBar,
  Tabs,
  Tab,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
} from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import USER_ROLES from '../common/userroles';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import moment from 'moment-timezone';
import { IMaskInput } from 'react-imask';
import { Box } from '@mui/system';
import { withTranslation } from 'react-i18next';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
import ReportsAGGrid from "../reports/reportsGrid/reportsAGGrid";
import VerticalMenu from "./ActionCellRenderer";
import CloseIcon from '@mui/icons-material/Close';

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component='div' dir={dir}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#00a7e1',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    uadd,
    udelete,
    t,
    clearFilters
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 1,
      })}
    >
      <div className={classes.title}>
        {numSelected > 1 ? (
          <Typography color='' variant='subheading'>
            {numSelected} {t('Users.SelectedRowsCount')}
          </Typography>
        ) : null}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 1 ? (
          udelete === true ? (
            <Tooltip key='multi-delete' title={t('Users.DeleteUsersTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                sx={() => ({
                  '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          )
        ) : uadd === true ? (
          <div style={{ display: 'flex', width: '90px', justifyContent: 'space-between' }}>
            <Tooltip style={{ marginRight: '10px' }} key="clear-filters" title={t("Users.ClearFiltersTooltip")}>
              <IconButton onClick={clearFilters} className={classes.add}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
            <Tooltip key='single-add' title={t('Users.AddUsersTooltip')}>
              <IconButton
                aria-label='Add User'
                className={classes.add}
                onClick={add}
              >
                <AddUserIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ''
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: '985px',
  },
  root: {
    width: '100%',
  },
  halfTextField: {
    marginRight: '20px',
  },
  dropbox: {
    width: '135px',
    height: '105px',
    float: 'right',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '56px',
    right: '2px',
    position: 'relative',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  errorDiv: {
    paddingTop: '10px',
    color: 'red',
  },
  captionText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    textAlign: 'center',
  },
  twoChildren: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftChild: {},
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  boxDesign: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  dialogTitle: {
    fontSize: '1.3125rem',
    fontWeight: 500,
    lineHeight: '1.16667em',
  },
  menuItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
});

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='(#00) 000-0000'
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

let imgFile;
const ITEM_ROLE_HEIGHT = 48;
const ITEM_ROLE_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_ROLE_HEIGHT * 4.5 + ITEM_ROLE_PADDING_TOP,
      width: 250,
    },
  },
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

const TransactionSortObj = {
  name: { tableName: '', sortColumn: 'name' },
  username: { tableName: '', sortColumn: 'username' },
  parent_account: { tableName: 'accounts', sortColumn: 'name' },
  email: { tableName: 'contacts', sortColumn: 'email' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  roles: { tableName: 'roles', sortColumn: 'name' },
  last_login_on: { tableName: '', sortColumn: 'last_login_on' }
}

let TransactionFilterObj = {
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
};

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      selected: [],
      page: 0,
      rowsPerPage: 25,
      submitted: false,
      isButtonDisabled: false,
      userview: true,
      useradd: true,
      userdelete: true,
      useredit: true,
      user: {
        first_name: '',
        last_name: '',
        badge_id: '',
        email: '',
        phone: '',
        roles: [],
      },
      loader: false,
      disabledText: 'Disable',
      chipstores: [],
      chipboxes: [],
      isDisabled: false,
      selectedTab: 0,
      workDayStarts: new Date(),
      workDayEnds: new Date(),
      defaultReminder: false,
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      emailNotify: false,
      smsNotify: false,
      pushNotify: false,
      isOpenReminderSelect: false,
      reminderSelectID: '5m',
      innerLoader: false,
      isDisabledScheduleButton: false,
      rowID: null,
      isSuperAdmin: false,
      isAdmin: false,
      totalRecords: 0,
      preferredLanguage: [
        { id: 'en', label: this.props.t('Global.Language.English') },
        { id: 'fr', label: this.props.t('Global.Language.French') },
      ],
      preferLanguage: 'en',
      loadState: 0,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      authenticateUnlockUserDialogConfirmation: false,
      selectedUserEmailToAuthenticat: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openUserPopup = () => {
    // eslint-disable-next-line no-restricted-globals
    let params = location.pathname.includes('/users');
    if (params) {
      // eslint-disable-next-line no-restricted-globals, no-unused-expressions
      let type = location.pathname.split('/users')[1];
      type = type.replace(/\D/g, '');
      if ((type === 1 || type === '1') && this.state.loadState === 0) {
        let loggedinUserID = JSON.parse(sessionStorage.getItem('user'))
          .username;
        this.setState({ selectedRowId: loggedinUserID }, () => {
          const selectedObject = this.state.data.find(
            (x) => x.id === this.state.selectedRowId
          );
          this.setState({
            loadState: 1,
            selectedTab: 0,

            showNewUserDialog: true,
            operation: 'Edit',
            user: selectedObject,
            parent_account_id: selectedObject.parent_account_id,
            first_name: selectedObject.first_name,
            last_name: selectedObject.last_name,
            badge_id: selectedObject.badge_id,
            email: selectedObject.email || selectedObject.contact.email,
            avatarPreview: selectedObject.picture_url,
            phone: selectedObject.phone || selectedObject.contact.phone,
            roles: selectedObject.roles,
            rowID: selectedObject && selectedObject.id,
            parentID: selectedObject && selectedObject.parent_account_id,
            workDayStarts:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.work_day_starts,
            workDayEnds:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.work_day_ends,
            reminderSelectID:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.reminder,
            defaultReminder:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_default_reminder,
            sunday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_sunday,
            monday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_monday,
            tuesday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_tuesday,
            wednesday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_wednesday,
            thursday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_thursday,
            friday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_friday,
            saturday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_saturday,
            emailNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_email,
            smsNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_sms,
            pushNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_push,
            preferLanguage: selectedObject && selectedObject.preferred_language,
          });
        });
      }
    }
  };

  componentDidMount() {
    this.setState({
      isSuperAdmin:
        sessionStorage.hasOwnProperty('superadmin') &&
        JSON.parse(sessionStorage.getItem('superadmin')) ===
        USER_ROLES.SUPERADMIN,
      isAdmin:
        sessionStorage.hasOwnProperty('admin') &&
        JSON.parse(sessionStorage.getItem('admin')) === USER_ROLES.ADMIN,
    });

    fetch(process.env.REACT_APP_BASEURL + 'roles', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roleLookupValues) => this.setState({ roleLookupValues }));

    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({
          accountValues,
          parent_account_id: accountValues[0].value,
        });
      });
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));
    if (permissions && permissions.length > 0) {
      let permissionObj = {};
      permissions.map((item) => {
        return item.permission_entity_type === 'Manage Users' &&
          item.name === 'View'
          ? (permissionObj.view = true)
          : item.permission_entity_type === 'Manage Users' &&
            item.name === 'Add '
            ? (permissionObj.add = true)
            : item.permission_entity_type === 'Manage Users' &&
              item.name === 'Modify '
              ? (permissionObj.modify = true)
              : item.permission_entity_type === 'Manage Users' &&
                item.name === 'Delete '
                ? (permissionObj.delete = true)
                : null;
      });
      if (permissionObj.view) {
        this.setState({ userview: true });
      } else {
        this.setState({ userview: false });
      }
      if (permissionObj.add) {
        this.setState({ useradd: true });
      } else {
        this.setState({ useradd: false });
      }
      if (permissionObj.modify) {
        this.setState({ useredit: true });
      } else {
        this.setState({ useredit: false });
      }
      if (permissionObj.delete) {
        this.setState({ userdelete: true });
      } else {
        this.setState({ userdelete: false });
      }
      if (permissions[22].is_allowed === false) {
        this.setState({ userview: false });
      }
      if (permissions[23].is_allowed === false) {
        this.setState({ useradd: false });
      }
      if (permissions[25].is_allowed === false) {
        this.setState({ userdelete: false });
      }
      if (permissions[24].is_allowed === false) {
        this.setState({ useredit: false });
      }
    } else {
      this.setState({ userview: false });
      this.setState({ useradd: false });
      this.setState({ useredit: false });
      this.setState({ userdelete: false });
    }
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  addUser = (event) => {
    this.setState({
      showNewUserDialog: true,
      user: {},
      operation: 'Add',
      first_name: '',
      last_name: '',
      badge_id: '',
      email: '',
      avatarPreview: null,
      phone: null,
      roles: null,
      disabledText: 'Disable',
      selectedTab: 0,
      chipstores: []
    });
  };

  deleteUsers = (event) => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      'users/' +
      this.state.selected.join(',').trim(','),
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
      const filterModel = this.gridApi.getFilterModel();
      if (Object.keys(filterModel).length > 0) {
        this.gridApi.setFilterModel(null);
        TransactionFilterObj.searchObject = null;
        TransactionFilterObj.fromdate = '';
        TransactionFilterObj.todate = '';
      }
      this.gridApi.refreshServerSide();
    });
  };

  handleClose = (event) => {
    this.setState({ showNewUserDialog: false, user: {}, errorMessage: '' });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  // isvalidEmail(email) {
  //   console.log('this.state.email', this.state.email);
  //   const trulyValue = email === this.state.email;
  //   if (!trulyValue) {
  //     return false;
  //   }
  //   return trulyValue;
  // }

  // checkEmail = (event) => {
  //   this.setState({ loader: true });
  //   const searchedString = event.target.value;
  //   this.setState({ email: searchedString });
  //   if (searchedString.length > 0) {
  //     let isvalid = this.isvalidEmail(searchedString);
  //     if (isvalid > 0) {
  //       fetch(
  //         process.env.REACT_APP_BASEURL +
  //         'checkemailexistornot/' +
  //         searchedString,
  //         {
  //           method: 'GET',
  //           withCredentials: true,
  //           headers: {
  //             'Content-Type': 'application/json',
  //             Authorization:
  //               'Bearer ' +
  //               JSON.parse(sessionStorage.getItem('user')).signInUserSession
  //                 .idToken.jwtToken,
  //           },
  //         }
  //       )
  //         .then((response) => response.json())
  //         .then((emailcheck) => {
  //           this.setState({ loader: false });
  //           if (emailcheck && emailcheck.email_Is_Exist) {
  //             toast.error(this.props.t('Toast.Error.Email'));
  //             this.setState({ email: '' });
  //           } else {
  //             this.setState({ emailcheck });
  //           }
  //         });
  //     } else this.setState({ loader: false });
  //   }
  // };

  normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };

  handleChange = (event) => {
    if (event.preventDefault) event.preventDefault();

    const { user } = this.state;
    const {
      target: { id, name, value },
    } = event;
    if (['email'].includes(name || id)) {
      user[name || id] = (value || '').toLowerCase();
    } else if (['phone'].includes(name || id)) {
      user[name || id] = this.normalizeInput(value)
    }
    else user[name || id] = value;
    this.setState(user);
  };

  removeImg = () => {
    const parent = document.getElementById('avatardropzone');
    let imgSrc = ((parent.children && parent.children[0]).src = '');
    imgFile = new File([imgSrc], 'filename');
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteUsers();
    }
    this.setState({ deleteDialogOpen: false });
    toast.success(this.props.t('Toast.Success.UserRemoved'));
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + 'users/' + rowIdToDelete,
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
        selectedRowId: null,
      });
      this.handleContextClose(event);
      const filterModel = this.gridApi.getFilterModel();
      if (Object.keys(filterModel).length > 0) {
        this.gridApi.setFilterModel(null);
        TransactionFilterObj.searchObject = null;
        TransactionFilterObj.fromdate = '';
        TransactionFilterObj.todate = '';
      }
      this.gridApi.refreshServerSide();
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      loader: true,
      isButtonDisabled: true,
    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    data.append('file', input.files[0]);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('badge_id', this.state.badge_id);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);
    if (this.state.roles && this.state.roles.length > 0) {
      data.append('roles', this.state.roles.map((x) => x.id));
    }

    const result = fetch(process.env.REACT_APP_BASEURL + 'users', {
      method: 'POST',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error || res.message) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,

            });
            if (res.success === false) {
              toast.error(res.message);
            } else {
              toast.error(
                this.props.t('Toast.Error.AdministratorContact')
              );
            }
          } else {
            this.state.data.unshift(res.user);
            const newData = JSON.parse(JSON.stringify(this.state.data));
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: newData,
            });
            toast.success(this.props.t('Toast.Success.UserAdded'));
            const filterModel = this.gridApi.getFilterModel();
            if (Object.keys(filterModel).length > 0) {
              this.gridApi.setFilterModel(null);
              TransactionFilterObj.searchObject = null;
              TransactionFilterObj.fromdate = '';
              TransactionFilterObj.todate = '';
            }
            this.gridApi.refreshServerSide();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message, isButtonDisabled: false });
      });
    this.gridApi.forEachNode(node => node.setSelected(false))
  };

  changeLanguage = () => {
    let loggedinUserID = JSON.parse(sessionStorage.getItem('user')).username;
    if (this.state.user.id !== loggedinUserID) {
      return true;
    }

    let preferLanguage = sessionStorage.getItem('preferredLanguage');
    if (this.state.preferLanguage !== preferLanguage) {
      sessionStorage.setItem('preferredLanguage', this.state.preferLanguage);
      const { i18n } = this.props;
      i18n.changeLanguage(this.state.preferLanguage);
    }
  };

  handleUpdate = (event) => {
    event.preventDefault();
    this.setState({
      loader: true,
      isButtonDisabled: true,

    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    if (
      input.files !== null &&
      input.files !== undefined &&
      input.files.length > 0
    ) {
      if (input.files[0] != null || '') {
        data.append('file', input.files[0] || this.state.user.picture_url);
      } else {
        data.append('file', imgFile[0]);
      }
    }
    data.append('id', this.state.user.id);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('badge_id', this.state.badge_id);
    data.append('contact_id', this.state.user.contact.id);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);
    if (this.state.roles && this.state.roles.length > 0) {
      data.append('roles', this.state.roles.map((x) => x.id));
    }

    const result = fetch(process.env.REACT_APP_BASEURL + 'users', {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,

            });
            this.setState({ errorMessage: res.error.message });
          } else {
            const newData = this.state.data.filter(
              (x) => x.id !== this.state.user.id
            );
            newData.unshift(res.user);
            this.changeLanguage();
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: JSON.parse(JSON.stringify(newData)),
            });
            toast.success(this.props.t('Toast.Success.UserUpdated'));
            const filterModel = this.gridApi.getFilterModel();
            if (Object.keys(filterModel).length > 0) {
              this.gridApi.setFilterModel(null);
              TransactionFilterObj.searchObject = null;
              TransactionFilterObj.fromdate = '';
              TransactionFilterObj.todate = '';
            }
            this.gridApi.refreshServerSide();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message });
      });
    this.gridApi.forEachNode(node => node.setSelected(false))
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleStoreChange = (event) => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex((x) => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        processed.push(this.state.roleLookupValues[i]);
      }
    } else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        const element = storeid.findIndex(
          (x) => x.id === this.state.roleLookupValues[i].id
        );
        if (element > -1) {
        } else {
          chipprocessed.push(this.state.roleLookupValues[i]);
          processed.push(this.state.roleLookupValues[i]);
        }
      }
    } else if (storeid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    } else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ roles: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id);
        }
      }
    }
  };

  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }

  handleWorkDayStartsChange = (startDays) => {
    this.setState({ workDayStarts: startDays });
  };

  handleWorkDayEndsChange = (endDays) => {
    this.setState({ workDayEnds: endDays });
  };

  handleCheckboxChange = (event) => {
    const value = event && event.target.name;
    switch (value) {
      case 'defaultReminder':
        this.setState({ defaultReminder: !this.state.defaultReminder });
        break;

      case 'ReminderSelect':
        this.setState({ reminderSelectID: event.target.value });
        break;

      case 'sunday':
        this.setState({ sunday: !this.state.sunday });
        break;

      case 'monday':
        this.setState({ monday: !this.state.monday });
        break;

      case 'tuesday':
        this.setState({ tuesday: !this.state.tuesday });
        break;

      case 'wednesday':
        this.setState({ wednesday: !this.state.wednesday });
        break;

      case 'thursday':
        this.setState({ thursday: !this.state.thursday });
        break;

      case 'friday':
        this.setState({ friday: !this.state.friday });
        break;

      case 'saturday':
        this.setState({ saturday: !this.state.saturday });
        break;

      case 'email':
        this.setState({ emailNotify: !this.state.emailNotify });
        break;

      case 'sms':
        this.setState({ smsNotify: !this.state.smsNotify });
        break;

      case 'push':
        this.setState({ pushNotify: !this.state.pushNotify });
        break;

      default:
        return null;
    }
  };

  handleCloseReminderSelect = () => {
    this.setState({ isOpenReminderSelect: false });
  };

  hanldeOpenReminderSelect = () => {
    this.setState({ isOpenReminderSelect: true });
  };
  // -- Need to enable when we deployed appountments.
  handleSubmitScheduleCalendar = (event) => {
    event.preventDefault();
    this.setState({ loader: true, isDisabledScheduleButton: true });
    try {
      const saveScheduleCalendar = {
        workDayStart: this.state && this.state.workDayStarts,
        workDayEnd: this.state && this.state.workDayEnds,
        reminder:
          this.state.defaultReminder === true
            ? '5m'
            : this.state.reminderSelectID,
        isDefaultReminder: this.state && this.state.defaultReminder,
        isSunday: this.state && this.state.sunday,
        isMonday: this.state && this.state.monday,
        isTuesday: this.state && this.state.tuesday,
        isWednesday: this.state && this.state.wednesday,
        isThursday: this.state && this.state.thursday,
        isFriday: this.state && this.state.friday,
        isSaturday: this.state && this.state.saturday,
        isEmail: this.state && this.state.emailNotify,
        isSms: this.state && this.state.smsNotify,
        isPush: this.state && this.state.pushNotify,
        userId: this.state && this.state.rowID,
        accountId: this.state && this.state.parentID,
      };
      fetch(process.env.REACT_APP_BASEURL + 'schedule/user-schedule-calender', {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(saveScheduleCalendar),
      })
        .then((res) => {
          try {
            return res.json();
          } catch (error) {
            return error;
          }
        })
        .then((response) => {
          if (response && response.status === 200) {
            if (
              response &&
              response._response &&
              response._response.createSchedule
            ) {
              this.setState({
                loader: false,
                isDisabledScheduleButton: false,
                showNewUserDialog: false,
                rowID: null,
                parentID: null,
              });
              toast.success(this.props.t('Toast.Success.ScheduleCalenderCreated'));
              this.gridApi.refreshServerSide();
              this.setState({
                workDayStarts: new Date(),
                workDayEnds: new Date(),
                reminderSelectID: '5m',
                defaultReminder: false,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                emailNotify: false,
                smsNotify: false,
                pushNotify: false,
                rowID: false,
                parentID: false,
              });
            } else {
              this.setState({
                loader: false,
                isDisabledScheduleButton: false,
                showNewUserDialog: false,
                rowID: null,
                parentID: null,
              });
              toast.success(this.props.t('Toast.Success.ScheduleCalenderUpdated'));
              this.gridApi.refreshServerSide();
              this.setState({
                workDayStarts: new Date(),
                workDayEnds: new Date(),
                reminderSelectID: '5m',
                defaultReminder: false,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                emailNotify: false,
                smsNotify: false,
                pushNotify: false,
                rowID: false,
                parentID: false,
              });
            }
          } else if (response && response.status === 500) {
            this.setState({
              loader: false,
              isDisabledScheduleButton: false,
              showNewUserDialog: false,
              rowID: null,
              parentID: null,
            });
            toast.error(response.res.error);
          }
        })
        .catch((error) => {
          this.setState({
            loader: false,
            isDisabledScheduleButton: false,
            showNewUserDialog: false,
            rowID: null,
            parentID: null,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChangePreferredLanguage = (event) => {
    event.preventDefault && event.preventDefault();
    const { value } = event.target;
    this.setState({ preferLanguage: value });
  };

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        // to set fromdate and todate
        if (filterObject.last_login_on) {
          const dateValue = filterObject.last_login_on;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }
        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getusers', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((data) => {
              self.setState({ totalRecords: data && data.total });
              if (data && data.results) {
                if (data.results.length > 0) {
                  params.successCallback(data.results, data.total);
                  self.setState({ data: data.results, loader: false, isDataEmpty: false, selected: [] },
                    () => { self.openUserPopup() })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], loader: false, isDataEmpty: true, selected: [] })
                }
                self.setState({ loader: false, selected: [] })
              }
            })
            .catch(error => {
              self.setState({ loader: false, selected: [] })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  onRowSelected = (params) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(params.data.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, params.data.id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };

  retrieveData = (selectedObject) => {
    this.setState({ ...selectedObject })
  }

  ActionCellRenderer = (t, classes) => {
    return (params) => {
      return (
        <VerticalMenu
          t={t}
          classes={classes}
          params={params}
          state={this.state}
          retrieveData={this.retrieveData}
        />
      )
    }
  }

  render() {
    const { classes, theme, t } = this.props;
    const {
      selected,
      user,
      // totalRecords,
      preferLanguage,
      locale,
    } = this.state;
    const readOnly = this.state.operation === 'View';
    let disableSelect = false;
    if (this.state.operation === 'View') {
      disableSelect = true;
    } else {
      disableSelect = false;
    }

    const columnDefs = [
      {
        field: "picture_url", headerName: t("Users.Picture"), sortable: false, filter: false, cellRenderer: (params) => (<Avatar alt="" src={params.data.picture_url} />),
      },
      { field: "name", headerName: t("Users.Name") },
      { field: "username", headerName: t("Users.UserName") },
      { field: "parent_account", headerName: t("Users.AssociatedAccount"), cellRenderer: (params) => params.data.parentAccount.name },
      { field: "email", headerName: t("Users.Email"), cellRenderer: (params) => params.data.contact.email },
      { field: "phone", headerName: t("Users.Phone"), cellRenderer: (params) => params.data.contact.phone },
      {
        field: "roles", headerName: t("Users.Roles"),
        cellRenderer: (params) => params.data.roles ? params.data.roles.map((x) => x.name).join(', ').trim(', ') : ''
      },
      {
        field: "last_login_on", headerName: t("Users.LastLogin"),
        cellRenderer: (params) => params.data.last_login_on ? this.convertToTimeZone(params.data.last_login_on) : '',
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Users.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Users.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      {
        field: "is_enabled", headerName: t("Users.Status"), sortable: false, filter: false,
        cellRenderer: (params) => params.data.is_enabled === true || params.data.is_enabled === 'true' ? t('Users.Enabled') : t('Users.DisableActions')
      },
      {
        field: "actions", headerName: t("Users.Actions"), minWidth: 120, filter: false, sortable: false,
        cellRenderer: this.ActionCellRenderer(t, classes)
      },
    ];

    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Users.AreYouSureDeleteText')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Users.AreYouSureDeleteBodyText')} :
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteCancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth='md'
          open={this.state.showNewUserDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
          classes={{ paper: classes.Paper }}
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <AppBar
            position='static'
            color='default'
            sx={{ backgroundColor: '#f5f5f5 !important' }}
          >
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant={null}
            >
              <Tab
                label={t('Users.UserDetails.UserDetailsTitle')}
                style={{ minWidth: '160px' }}
              />
              {(this.state.operation === 'Edit' ||
                this.state.operation === 'View') && (
                  <Tab
                    label={t('Users.Calendar.CalendarTitle')}
                    style={{ minWidth: '160px' }}
                  />
                )}
            </Tabs>
          </AppBar>
          <SwipeableViews
            style={{ maxWidth: '1025px' }}
            axis={theme && theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.selectedTab}
            onChangeIndex={() => this.handleChangeIndex}
          >
            <TabContainer dir={theme && theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <ValidatorForm
                  ref='form'
                  onSubmit={
                    this.state.operation === 'Add'
                      ? this.handleSubmit
                      : this.handleUpdate
                  }

                >
                  <DialogTitle id='form-dialog-title'>
                    {t(this.state.operation)} {t('Users.UserDetails.User')}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {this.state.operation === 'Add'
                        ? t('Users.UserDetails.UsersDetailsText')
                        : ''}

                      <span className={classes.errorDiv}>
                        {this.state.errorMessage}
                      </span>
                    </DialogContentText>
                    <Selector
                      id='parent_account_id'
                      label={t('Users.UserDetails.ParentAccount')}
                      values={this.state.accountValues}
                      selected={this.state.parent_account_id}
                      onBlur={this.handleChange}
                      readOnly={readOnly}
                      disableWhenViewSelect={disableSelect}
                    />
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={user.first_name || this.state.first_name}
                            id='first_name'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Users.UserDetails.FirstName')}
                            name='first_name'
                            type='first-name'
                            placeholder=''
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Patient.Validation.EnterPatientRecordNumber'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='last_name'
                            value={user.last_name || this.state.last_name}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Users.UserDetails.LastName')}
                            name='last_name'
                            type='last-name'
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Validation.EnterLastName'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='email'
                            disabled={['view', 'edit'].includes(
                              this.state.operation
                            )}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              autocomplete: 'off',
                            }}
                            value={String(
                              user.email || this.state.email
                            ).toLowerCase()}
                            label={t('Users.UserDetails.EmailAddress')}
                            type='email'
                            name='email'
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                              t('Validation.EnterEmailAddress'),
                              t('Validation.EmailIsNotValid'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            label={t('Users.UserDetails.PhoneNumber')}
                            value={user.phone || this.state.phone}
                            onChange={this.handleChange}
                            name='phone'
                            id='phone'
                            style={{ width: '350px' }}
                            InputProps={{
                              inputComponent: TextMaskCustom,
                              inputProps: {
                                autocomplete: 'off',
                                readOnly: Boolean(readOnly),
                              },
                            }}
                            variant='standard'
                            validators={['required', 'matchRegexp:^.{14,}$']}
                            errorMessages={[t('Validation.EnterPhoneNumber'), "enter valid number"]}
                          />

                        </div>
                        <Box sx={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            style={{ width: '350px' }}
                            fullWidth
                            margin='normal'
                            id='badge_id'
                            value={user.badge_id || this.state.badge_id}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autocomplete: 'off',
                            }}
                            label={t('Users.UserDetails.BadgeID')}
                            name='badge_id'
                            type='badge_id'
                            onChange={this.handleChange}
                            variant='standard'
                          />
                          <FormControl
                            variant='standard'
                            sx={{ m: '16px 0', minWidth: 347 }}
                          >
                            <InputLabel id='preferred-language-label'>
                              {t('Users.UserDetails.PreferredLanguage')}
                            </InputLabel>
                            <Select
                              labelId='preferred-language-label'
                              id='preferred-language-select-standard'
                              value={preferLanguage || ''}
                              readOnly={readOnly}
                              onChange={this.onChangePreferredLanguage}
                              label={t('Users.UserDetails.PreferredLanguage')}
                            >
                              {this.state &&
                                this.state.preferredLanguage.map(
                                  (item, index) => (
                                    <MenuItem
                                      key={index}
                                      value={item && item.id}
                                      selected
                                    >
                                      {item && item.label}
                                    </MenuItem>
                                  )
                                )}
                            </Select>
                          </FormControl>
                        </Box>
                      </div>
                      <div className={classes.rightChild}>
                        <div className={classes.dropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='avatardropzone'
                              onDrop={this.handleDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <br />
                        <div variant='caption' style={{ paddingTop: '40px' }}>
                          <p className={classes.captionText}>
                            {t('Users.UserDetails.UploadImage')}
                          </p>
                          <Button onClick={this.removeImg}>
                            {t('Users.UserDetails.RemoveImage')}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <br />
                    <InputLabel htmlFor='select-multiple-chip'>
                      {t('Users.UserDetails.Roles')}
                    </InputLabel>
                    <Select
                      multiple
                      fullWidth
                      readOnly={readOnly}
                      value={this.state.chipstores}
                      onChange={this.handleStoreChange}
                      input={<Input id='select-multiple-chip' />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value.id}
                              label={value.name}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {(this.state && this.state.roleLookupValues) !==
                        undefined &&
                        this.state.roleLookupValues.map &&
                        this.state.roleLookupValues.map((item) => (
                          <MenuItem key={item.id} value={item}>
                            <Checkbox
                              checked={
                                this.state &&
                                this.state.roles &&
                                this.state.roles.map &&
                                this.state.roles
                                  .map((x) => x.id)
                                  .indexOf(item.id) > -1
                              }
                            />
                            <ListItemText primary={t(item.name_es)} />
                          </MenuItem>
                        ))}
                    </Select>
                    <br />
                  </DialogContent>
                  <div style={{ bottom: '0', width: '100%' }}>
                    <DialogActions sx={{ padding: '15px 12px 9px 4px' }}>
                      <Button
                        onClick={this.handleClose}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'View'
                          ? t('Users.CloseButton')
                          : t('Users.CancelButton')}
                      </Button>
                      {this.state.operation !== 'View' && (
                        <Button
                          type='submit'
                          disabled={this.state.isButtonDisabled}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {this.state.operation === 'Edit'
                            ? t('Users.UpdatePatientButton')
                            : t('Users.AddPatientButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </ValidatorForm>
              </div>
            </TabContainer>
            <TabContainer dir={theme && theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <ValidatorForm
                  ref='form'
                  onSubmit={this.handleSubmitScheduleCalendar}
                >
                  <DialogTitle
                    id='form-dialog-title'
                    className={classes.dialogTitle}
                  >
                    {t('Users.Calendar.WorkSchedule')}
                  </DialogTitle>
                  <DialogContent>
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <Grid container>
                          <Grid item xs={6}>
                            <FormControl
                              className={classes.halfTextField}
                              style={{ marginTop: '16px', marginBottom: '8px' }}
                            >
                              <LocalizationProvider
                                dateAdapter={DateAdapter}
                                locale={locale}
                              >
                                <div>
                                  <div className='picker'>
                                    <DesktopDatePicker
                                      keyboard
                                      clearable
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      disableFuture
                                      onChange={this.handleWorkDayStartsChange}
                                      disabled={readOnly}
                                      style={{ width: '400px' }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            'Users.Calendar.WorkDayStarts'
                                          )}
                                          variant='standard'
                                          sx={{
                                            '&.MuiFormControl-root': {
                                              width: '400px',
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {/* <TimePicker
                                      keyboard
                                      ampm={true}
                                      margin='normal'
                                      id='time-picker'
                                      label='Work day starts'
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      onChange={this.handleWorkDayStartsChange}
                                      KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                      }}
                                      style={{ width: '400px' }}
                                      disabled={readOnly}
                                    /> */}
                                  </div>
                                </div>
                              </LocalizationProvider>
                            </FormControl>
                            <FormControl
                              className={classes.halfTextField}
                              style={{
                                marginTop: '16px',
                                marginBottom: '27px',
                              }}
                            >
                              <LocalizationProvider
                                dateAdapter={DateAdapter}
                                locale={locale}
                              >
                                <div>
                                  <div className='picker'>
                                    <DesktopDatePicker
                                      keyboard
                                      clearable
                                      value={
                                        this.state && this.state.workDayEnds
                                      }
                                      //format="MM/DD/YYYY"
                                      //placeholder="12/31/1984"
                                      disableFuture
                                      onChange={this.handleWorkDayEndsChange}
                                      disabled={readOnly}
                                      style={{ width: '400px' }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            'Users.Calendar.WorkDayEnds'
                                          )}
                                          variant='standard'
                                          sx={{
                                            '&.MuiFormControl-root': {
                                              width: '400px',
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {/* <TimePicker
                                      keyboard
                                      ampm={true}
                                      margin='normal'
                                      id='time-picker'
                                      label='Work day starts'
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      onChange={this.handleWorkDayStartsChange}
                                      KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                      }}
                                      style={{ width: '400px' }}
                                      disabled={readOnly}
                                    /> */}
                                  </div>
                                </div>
                              </LocalizationProvider>
                            </FormControl>
                            <Typography
                              variant='title'
                              style={{ marginTop: '25px' }}
                              className={classes.dialogTitle}
                            >
                              {t('Users.Calendar.CalendarOptions')}
                            </Typography>
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={Boolean(readOnly)}
                                    name='defaultReminder'
                                    checked={this.state.defaultReminder}
                                    onChange={this.handleCheckboxChange}
                                    value={this.state.defaultReminder}
                                    color='primary'
                                  />
                                }
                                label={t('Users.Calendar.DefaultReminder')}
                              />
                            </div>
                            {this.state.defaultReminder === false && (
                              <FormControl style={{ width: '350px' }}>
                                <SelectValidator
                                  fullWidth
                                  autoFocus={false}
                                  id='demo-controlled-open-select'
                                  name='ReminderSelect'
                                  label={t('Users.Calendar.Reminder')}
                                  open={
                                    this.state &&
                                    this.state.isOpenReminderSelect
                                  }
                                  onClose={this.handleCloseReminderSelect}
                                  onOpen={this.hanldeOpenReminderSelect}
                                  onChange={this.handleCheckboxChange}
                                  value={
                                    this.state &&
                                    (this.state.reminderSelectID || '')
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                  }}
                                  variant='standard'
                                >
                                  <MenuItem
                                    value='5m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    5m
                                  </MenuItem>
                                  <MenuItem
                                    value='10m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    10m
                                  </MenuItem>
                                  <MenuItem
                                    value='15m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    15m
                                  </MenuItem>
                                  <MenuItem
                                    value='30m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    30m
                                  </MenuItem>
                                </SelectValidator>
                              </FormControl>
                            )}
                          </Grid>
                          <Grid item xs={3}>
                            <div className={classes.boxDesign}>
                              <Typography
                                variant='title'
                                className={classes.dialogTitle}
                              >
                                {t('Users.Calendar.WorkWeek')}
                              </Typography>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='sunday'
                                      checked={this.state.sunday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.sunday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Sunday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='monday'
                                      checked={this.state.monday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.monday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Monday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='tuesday'
                                      checked={this.state.tuesday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.tuesday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Tuesday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='wednesday'
                                      checked={this.state.wednesday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.wednesday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Wednesday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='thursday'
                                      checked={this.state.thursday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.thursday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Thursday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='friday'
                                      checked={this.state.friday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.friday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Friday')}
                                    </span>
                                  }
                                />
                              </div>

                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='saturday'
                                      checked={this.state.saturday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.saturday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Saturday')}
                                    </span>
                                  }
                                />
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={3}>
                            <div className={classes.boxDesign}>
                              <Typography
                                variant='title'
                                className={classes.dialogTitle}
                              >
                                {t('Users.Calendar.Notification')}
                              </Typography>
                              <div>
                                <FormControl component='fieldset'>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='email'
                                          value={this.state.emailNotify}
                                          checked={this.state.emailNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.Email')}
                                    />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='sms'
                                          value={this.state.smsNotify}
                                          checked={this.state.smsNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.SMS')}
                                    />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='push'
                                          value={this.state.pushNotify}
                                          checked={this.state.pushNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.Push')}
                                    />
                                  </FormGroup>
                                </FormControl>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </DialogContent>
                  <div
                    style={{ position: 'absolute', bottom: '0', width: '100%' }}
                  >
                    <DialogActions sx={{ padding: '8px 12px 8px 8px' }}>
                      {(this.state.operation === 'Edit' ||
                        this.state.operation === 'View') && (
                          <Button
                            onClick={this.handleClose}
                            color='primary'
                            className={classes.primaryButton}
                          >
                            {this.state.operation === 'View'
                              ? t('Users.CloseButton')
                              : t('Users.CancelButton')}
                          </Button>
                        )}
                      {this.state.operation === 'Edit' && (
                        <Button
                          type='submit'
                          disabled={this.state.isDisabledScheduleButton}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {t('Users.Calendar.ScheduleCalendarButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </ValidatorForm>
              </div>
            </TabContainer>
          </SwipeableViews>
        </Dialog>
        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          deleteUsers={this.deleteUsers}
          clearFilters={this.clearFilters}
          confirmDelete={this.confirmDelete}
          uadd={this.state.useradd}
          udelete={this.state.userdelete}
        />
        <ReportsAGGrid
          columnDefs={columnDefs}
          sideBar={false}
          suppressMenuHide={true}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: [{
                displayKey: 'searchtext',
                displayName: 'Search Text',
                predicate: (cellValue) => cellValue
              }],
              maxNumConditions: 1,
            },
            resizable: true,
            sortable: true,
            menuTabs: ['generalMenuTab', 'columnsMenuTab'],

          }}
          rowHeight={45}
          onGridReady={this.onGridReady}
          getRowId={(params) => params.data.id}
          onRowSelected={this.onRowSelected}
        />
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/user-list/index.js